import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
	resetUnitRequested,
	setActiveKey,
} from '../../../../redux/myCourse/myCourse.actions';
import { htmlDecode } from '../../../../utils/commonFunctions';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Accordion from 'react-bootstrap/Accordion';
import ElementList from '../elements';

import ListAnimation from '../../../utils/animations/list';
const mapStateToProps = (state) => {
	const {
		units,
		requestedUnit,
		currentUnitOrder,
		coursedetails: { course_id },
		activeUnit,
	} = state.rootReducer.myCourse;
	return {
		units,
		requestedUnit,
		currentUnitOrder,
		course_id,
		activeUnit,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		resetUnitRequested: () => dispatch(resetUnitRequested()),
		setActiveKey: (val) => dispatch(setActiveKey(val)),
	};
};

const UnitTabHeader = ({
	units,
	requestedUnit,
	currentUnitOrder,
	resetUnitRequested,
	setActiveKey,
	course_id,
	activeUnit,
	elementFilter,
}) => {
	useEffect(() => {
		return () => {
			if (
				requestedUnit > -1 &&
				!parseInt(sessionStorage.getItem('activeSessionUnit'), 10)
			) {
				resetUnitRequested();
			}
		};
	}, [resetUnitRequested, requestedUnit]);

	useEffect(() => {
		setActiveKey(
			requestedUnit > -1 ? parseInt(requestedUnit) : parseInt(currentUnitOrder),
		);
	}, [currentUnitOrder, requestedUnit, setActiveKey]);

	return (
		<ListAnimation>
			{!!units &&
				Object.keys(units).map((unit) => {
					const {
						course_elements,
						unit_name,
						completed_activites,
						total_activites,
					} = units[unit];
					const filteredCourse = course_elements.filter((x) =>
						!!elementFilter && elementFilter.toLowerCase() !== 'any'
							? x.element_theme === elementFilter
							: x,
					);

					const percentComplete = Math.round(
						(completed_activites * 100) / total_activites,
					);

					return (
						<Accordion
							key={parseInt(unit, 10)}
							activeKey={activeUnit}
							onSelect={() =>
								setActiveKey(
									activeUnit === parseInt(unit, 10) ? -1 : parseInt(unit, 10),
								)
							}
						>
							<Card>
								<Accordion.Toggle
									id={`unit_${course_id}_${unit}`}
									as={Card.Header}
									className="border-bottom"
									eventKey={parseInt(unit, 10)}
								>
									<div className="unitHeader justify-between">
										{htmlDecode(unit_name)}
										{course_id != 507 ? (
										<div className="display-flex justify-between">
											<h4 className="unitProgress">
												{completed_activites} of {total_activites} Activities
											</h4>
											<div className="divProgress">
												<span
													className="progpercent"
													style={{ width: percentComplete + 'px' }}
												></span>
												<span className="progpercenttext">{percentComplete}%</span>
											</div>
										</div>
										) : null}
									</div>
								</Accordion.Toggle>
								<Accordion.Collapse eventKey={parseInt(unit, 10)}>
									<Card.Body>
										{!!filteredCourse && filteredCourse.length > 0 ? (
											<Row className="elementsContainer">
												{filteredCourse.map((elementDetails) => (
													<ElementList
														key={elementDetails.elementID}
														elementDetails={elementDetails}
													/>
												))}
											</Row>
										) : (
											<p className="no-activity">
												No Activities in this Unit that match your "I want to..." preference
												above.
											</p>
										)}
									</Card.Body>
								</Accordion.Collapse>
							</Card>
						</Accordion>
					);
				})}
		</ListAnimation>
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(UnitTabHeader);
